export default [
    {
        entity: 'Access Management',
        permissions: ['userlist', 'grouplist', 'organization', 'organizationlist'],
    },
    {
        entity: 'Order Management',
        permissions: ['orderdetails', 'accountdetails', 'customerdetails'],
    },
    {
        entity: 'Paylink Management',
        permissions: ['checkoutdetails'],
    },
    {
        entity: 'Report Management',
        permissions: ['settlementdetails', 'periodicreportdetails'],
    },
    {
        entity: 'Api key Management',
        permissions: ['apisecret'],
    },
    {
        entity: 'Onboarding Management',
        permissions: ['onboarding'],
    },
    {
        entity: 'Store Management',
        permissions: ['store'],
    },
    {
        entity: 'Dashboard Management',
        permissions: ['dashboard'],
    },
    {
        entity: 'TeamSales Management',
        permissions: ['creditaccount'],
    },
    {
        entity: 'Webhook Management',
        permissions: ['webhookendpoints'],
    },
    {
        entity: 'Developer Logs',
        permissions: ['developerlogs'],
    },
    {
        entity: 'B2B',
        permissions: ['buyermanagement'],
    },
    {
        entity: 'MFA',
        permissions: ['mfa'],
        forInternalUsersOnly: true,
    },
];
